// src/pages/dashboard/wallet-detail/shared/WalletMnemonicModal.tsx
import React from 'react';
import { CopyIcon } from '../../../../components/ui/Icons';
import { copyToClipboard } from './wallet-utils';
import '../../../../assets/styles/wallet-detail-button.css'; // Importamos los estilos de botones

interface WalletMnemonicModalProps {
  mnemonicData: string | null;
  onClose: () => void;
}

export default function WalletMnemonicModal({ mnemonicData, onClose }: WalletMnemonicModalProps) {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[1000]">
      <div className="bg-white px-2 py-3 sm:!p-8 rounded-xl w-[90%] max-w-[500px]">
        <h3 className="mb-1 sm:!mb-5 text-xl text-center font-semibold">Recovery Seed Phrase</h3>

        <div className="p-1 sm:!p-5 bg-gray-100 rounded-md mb-1 sm:!mb-5 relative flex flex-col items-center">
          {mnemonicData ? (
            <>
              <div className="grid grid-cols-3 gap-1 sm:!gap-2 w-full mb-2.5">
                {mnemonicData.split(' ').map((word, index) => (
                  <div
                    key={index}
                    className="p-2 bg-white border border-gray-300 rounded text-sm text-center"
                  >
                    <span className="text-gray-500 mr-1">{index + 1}.</span>{word}
                  </div>
                ))}
              </div>
              <button
                onClick={() => copyToClipboard(mnemonicData)}
                className="flex items-center gap-1 text-yellow-600 text-sm hover:underline"
              >
                <CopyIcon size={16} /> Copy All Words
              </button>
            </>
          ) : (
            <p className="text-center">Loading seed phrase...</p>
          )}
        </div>

        <div className="bg-yellow-100 text-yellow-800 p-2 sm:!p-4 rounded-md mb-1 sm:!mb-5 text-sm">
          <p className="mb-2">⚠️ <strong>CRITICAL SECURITY WARNING:</strong></p>
          <ul className="pl-5 list-disc">
            <li className="mb-1">This recovery seed phrase gives full access to your wallet.</li>
            <li className="mb-1">Never share these words with anyone or enter them into any website.</li>
            <li className="mb-1">Write these words down on paper and store them in a secure location.</li>
            <li className="mb-1">Do not take a screenshot or store them digitally without encryption.</li>
            <li>If you lose these words, you will permanently lose access to your funds.</li>
          </ul>
        </div>

        <div className="flex justify-center mb-1">
          <button
            onClick={onClose}
            className="wallet-btn wallet-btn-default"
          >
            I've Safely Stored My Seed Phrase
          </button>
        </div>
      </div>
    </div>

  );
}